import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant, DM_Mono, Instrument_Sans } from 'next/font/google'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { ToneController } from '@/components/generals/tone-controller'

const sans = Instrument_Sans({
    subsets: ['latin']
})

const mono = DM_Mono({
    subsets: ['latin'],
    weight: ['300', '400', '500']
})

const heading = Cormorant({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <SmoothScroll>
                <ToneController />
                <Component {...pageProps} />
            </SmoothScroll>

            <div className='grain' aria-hidden='true' />
        </div>
    )
}

export default App
